import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { getIntegrationDefinition } from '@next-adapter/integration-registry.js'
import { normalizeInstalledIntegrations } from './normalize-installed-integrations.js'

export function hasInstalledIntegrationFeature(
  config: ResolvedBetterstartConfig,
  feature: string
): boolean {
  return normalizeInstalledIntegrations(config).some((integrationId) =>
    getIntegrationDefinition(integrationId).capabilities?.formFeatures?.includes(feature)
  )
}
